import React, { lazy, Suspense } from "react";
import DefaultLoader from "../utilities/loaders/DefaultLoader";
const MembershipRequestContent = lazy(
    () => import("./MembershipRequestContent"),
);

const Membership = () => {
    return (
        <Suspense fallback={<DefaultLoader />}>
            <MembershipRequestContent />
        </Suspense>
    );
};

export default Membership;
